import { ZySignOutAlert } from '@/components/common/zysign-out-alert';
import { Button } from '@/components/ui/button';
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Separator } from '@/components/ui/separator';
import { Switch } from '@/components/ui/switch';
import authService from '@/services/zybook-auth-service';
import { useState } from 'react';

export function ZyMyProfile({
    showMyProfileModal,
    setShowMyProfileModal,
}: {
    showMyProfileModal: boolean;
    setShowMyProfileModal: (showMyProfileModal: boolean) => void;
}) {
    const [showSignOutAlert, setShowSignOutAlert] = useState(false);
    const [isChecked, setIsChecked] = useState<boolean>(authService.canSeeAllMAContent());

    async function handleToggleSeeAllMAContent() {
        const previous = isChecked;
        setIsChecked(!previous);
        const didToggleMAContent = await authService.toggleSeeAllMAContent();
        if (!didToggleMAContent) {
            setIsChecked(previous);
            return;
        }

        window.location.reload();
    }

    return (
        <>
            <Dialog
                open={showMyProfileModal}
                onOpenChange={setShowMyProfileModal}
            >
                <DialogContent>
                    <DialogHeader>
                        <DialogTitle className="text-xl">My Profile</DialogTitle>
                    </DialogHeader>
                    <div className="flex flex-col gap-2">{authService.getUserFullName()}</div>
                    <Separator />
                    <div className="flex gap-2">
                        <h3 className="text-sm font-medium">Password</h3>
                        <p className="text-sm text-muted-foreground">Last updated {authService.getUserPasswordLastUpdated()}</p>
                    </div>
                    <Separator />
                    <div className="flex gap-2">
                        <h3 className="text-sm font-medium">Email</h3>
                        <p className="text-sm text-muted-foreground">
                            Primary: {authService.getUserPrimaryEmail() || 'No primary email found'}
                        </p>
                    </div>
                    {authService.canToggleAllMAContent() && (
                        <>
                            <Separator />
                            <div className="flex gap-4">
                                <h3 className="text-sm font-medium">See All MA Content</h3>
                                <Switch
                                    checked={isChecked}
                                    onCheckedChange={handleToggleSeeAllMAContent}
                                />
                            </div>
                        </>
                    )}
                    <DialogFooter className="pt-2">
                        <Button
                            type="button"
                            variant="outline"
                            onClick={() => setShowSignOutAlert(true)}
                        >
                            Sign out
                        </Button>
                    </DialogFooter>
                </DialogContent>
            </Dialog>

            <ZySignOutAlert
                showSignOutAlert={showSignOutAlert}
                setShowSignOutAlert={setShowSignOutAlert}
            />
        </>
    );
}
